import DATA from '../../pages/content-block-page/data'
import METADATA from '../../pages/content-block-page/metadata'

if (!window.__persistContentBlockData) {
    window.__persistContentBlockData = {
        list: [...DATA],
        metadata: METADATA
    }
}

const OP_VALUE_SEPARATOR = ':'
const VALUE_SEPARATOR = ','

export default class OspreyContentBlocks {

    static __generateFakeResponse(body) {
        return {
            headers: {
                'content-type': 'application/json'
            },
            data: body
        }
    }

    static __getData(params) {
        const { ps, pc, sf, sd, q, fields, ...filterData } = params

        let data = [...window.__persistContentBlockData.list]

        if (q) {
            data = data.filter(item => item.name.value.toLowerCase().indexOf(q.toLowerCase()) >= 0)
        }

        if (sf) {
            const sdInt = sd.toLowerCase() === 'asc' ? 1 : -1
            data.sort((a, b) => {
                let comp = 0
                const av = a[sf] === null ? 0 : a[sf].value
                const bv = b[sf] === null ? 0 : b[sf].value

                if (typeof av === 'number' && typeof bv === 'number') {
                    comp = av - bv
                }
                else {
                    comp = av.toString().localeCompare(bv.toString())
                }

                return comp * sdInt
            })
        }

        const { channel, created, modified, archived, tags } = filterData

        if (channel) {
            const channelArray = channel.split(VALUE_SEPARATOR)
            data = data.filter((item) =>
            channelArray.every((value) => {
                    return (item.contentBlocks.value.filter((channel) => channel.children.channel.value === value).length > 0)
                })
            )
        }

        if (created) {
            const parts = created.split(OP_VALUE_SEPARATOR)
            data = data.filter((item) => this._compareValues(parts, item.created.value))
        }

        if (modified) {
            const parts = modified.split(OP_VALUE_SEPARATOR)
            data = data.filter((item) => this._compareValues(parts, item.modified.value))
        }

        if (archived) {
            data = data.filter((item) => item.archived.value === archived)
        }

        if (tags) {
            const tagKeyArray = tags.split(VALUE_SEPARATOR)
            data = data.filter((item) =>
                tagKeyArray.every((value) => {
                    return (item.tags.value.filter((tag) => tag.children.id.value === value).length > 0)
                })
            )
        }

        const pageStart = ps || 0

        const pagination = {
            total: data.length,
            count: pc === undefined ? data.length : Math.min(pc, data.length),
            start: pageStart
        }

        if (pc !== undefined) {
            data = data.slice(pageStart, Math.min(pageStart + pc, window.__persistContentBlockData.list.length))
        }

        if (fields) {
            const fieldArray = fields.split(VALUE_SEPARATOR).filter(c => c)
            data = data.map((item) => {
                const result = {}

                fieldArray.map((f) => {
                    const name = f.trim()
                    result[name] = item[name]
                })

                return result
            })
        }

        return {
            metadata: {
                pagination
            },
            results: data
        }
    }

    static _compareValues(parts, value) {
        const [op, opValueStr] = parts
        const opValue = parseInt(opValueStr)

        switch (op) {
            case 'gte':
                return value >= opValue

            case 'lte':
                return value <= opValue

            case 'e':
                return value === opValue

            case 'gt':
                return value > opValue

            case 'lt':
                return value < opValue

            default:
                return false
        }
    }

    static __getMetadata() {
        return window.__persistContentBlockData.metadata
    }

    static __getDataById(id) {
        const data = [...window.__persistContentBlockData.list]
        return data.filter(item => item.id.value === id)[0]
    }

    static get(path, params) {
        return new Promise((resolve, reject) => {
            let data = null

            const pathParts = path.split('/').filter(p => p)

            const [contentBlockRoute, subRoute] = pathParts

            if (contentBlockRoute !== 'content-blocks') {
                reject(new Error('invalid route'))
            }

            if (!subRoute) {
                data = this.__getData(params)
            }
            else {
                switch (subRoute) {
                    case 'metadata': {
                        data = this.__getMetadata()
                        break
                    }

                    default: { //:id
                        data = this.__getDataById(subRoute)
                        break
                    }
                }
            }
            resolve(this.__generateFakeResponse(data))
        })
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-content-blocks.js